export default "__VITE_ASSET__BBeT1$xc__"